<template>
  <section class="behno_press_tmb">
    <div class="press_container_tmb">
      <h2 class="behono_press_heading" v-html="shopifyData.secHeading" />
      <div class="block_wrapper">
        <div class="grid_block_1">
          <template v-for="(value, key) in shopifyData.pressImg" :key="key">
            <div v-if="value.pressImg" class="logo_img">
              <img
                v-lazy="value.pressImg.src"
                :src-placeholder="value.pressImg.placeholder"
                :alt="value.pressImg.alt || 'Press Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Press Image"
                width=""
                height=""
              />
            </div>
            <div v-if="value.pressImg2" class="big_img">
              <img
                v-lazy="value.pressImg2.src"
                :src-placeholder="value.pressImg2.placeholder"
                :alt="value.pressImg2.alt || 'Press Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Press Image"
                width=""
                height=""
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.behno_press_tmb {
  padding-top: 60px;
}
.press_container_tmb {
  max-width: 1210px;
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
}
.behno_press_tmb img {
  display: block;
  line-height: 0;
}
.behono_press_heading {
  font-size: 15px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-align: center;
  font-weight: 700;
}
.grid_block_1 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: space-between;
  gap: 20px;
}
.big_img {
  grid-row: span 3;
  align-self: center;
  grid-column: span 2;
}

@media screen and (max-width: 767px) {
  .grid_block_1 {
    grid-template-columns: repeat(2, 1fr);
  }
  .behno_press_tmb {
    padding-top: 44px;
  }
}
@media screen and (max-width: 575px) {
  .grid_block_1 {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
